var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 33,
    viewBox: "0 0 25 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4893 20.166C12.9512 20.166 13.3486 19.7793 13.3486 19.3281V8.2959L13.2842 6.68457L14.0039 7.44727L15.6367 9.1875C15.7871 9.35938 16.002 9.44531 16.2168 9.44531C16.6572 9.44531 17.001 9.12305 17.001 8.68262C17.001 8.45703 16.9043 8.28516 16.7432 8.12402L13.1123 4.62207C12.8975 4.40723 12.7148 4.33203 12.4893 4.33203C12.2744 4.33203 12.0918 4.40723 11.8662 4.62207L8.23535 8.12402C8.07422 8.28516 7.98828 8.45703 7.98828 8.68262C7.98828 9.12305 8.31055 9.44531 8.76172 9.44531C8.96582 9.44531 9.20215 9.35938 9.35254 9.1875L10.9746 7.44727L11.7051 6.68457L11.6406 8.2959V19.3281C11.6406 19.7793 12.0273 20.166 12.4893 20.166ZM6.33398 28.5771H18.6553C20.9004 28.5771 22.0283 27.46 22.0283 25.2471V14.5264C22.0283 12.3135 20.9004 11.1963 18.6553 11.1963H15.6582V12.9258H18.623C19.6865 12.9258 20.2988 13.5059 20.2988 14.623V25.1504C20.2988 26.2676 19.6865 26.8477 18.623 26.8477H6.35547C5.28125 26.8477 4.69043 26.2676 4.69043 25.1504V14.623C4.69043 13.5059 5.28125 12.9258 6.35547 12.9258H9.33105V11.1963H6.33398C4.08887 11.1963 2.96094 12.3135 2.96094 14.5264V25.2471C2.96094 27.46 4.08887 28.5771 6.33398 28.5771Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.7200f5e25344249d36ada653b7b596db.svg";
export { ForwardRef as ReactComponent };